<template>
	<div class="add_bg">
		<div class="left">
			<div class="title_div">From:</div>
			<div class="one_01">
				<el-tree ref="treeFrom" :data="listDataFrom" :props="defaultProps" :check-strictly="true" :highlight-current="highlightBd" @node-click="handleNodeClickFrom"></el-tree>
			</div>
		</div>
		<div class="middle">
			<div class="title_div">To:</div>
			<div class="one_01">
				<el-tree ref="treeTo" :data="listDataTo" :props="defaultProps" :check-strictly="true" :highlight-current="highlightBd" @node-click="handleNodeClickTo"></el-tree>
			</div>
		</div>
		<div class="right">
			<div class="title_div">条件配置:</div>
			<div class="add_btn">
				<el-button size="mini" @click="addCondition">新增条件</el-button>
			</div>

			<div class="pz_div">
				<div class="pz_content">
					<div class="bg_title">设置流转形式</div>
					<div class="pz_c">
						<div v-for="item in oneList" :key="item.code" class="pz_item">
							<span>{{ item.name }}</span>
						</div>
					</div>
				</div>
				<div class="pz_content">
					<div class="bg_title">设置流转条件</div>
					<div class="pz_c">
						<div v-for="item in twoList" :key="item.code" class="pz_item">
							<span>{{ item.name }}</span>
						</div>
					</div>
				</div>
			</div>
			<div class="save_btn">
				<el-button size="small" type="primary" :loading="saveloading" class="title" @click="submitForm">保存</el-button>
			</div>
		</div>

		<conditionEdit ref="conditionEdit"></conditionEdit>
	</div>
</template>
<script>
import { GetMenuTreeAllList, GetMenuConditionDtlList, SaveMenuCondition } from "../../../api/menuApi.js";
import conditionEdit from "./conditionEdit";
export default {
	data() {
		return {
			saveloading: false,
			loading: false,
			listDataFrom: [],
			listDataTo: [],
			defaultProps: {
				children: "subList",
				label: "menuName"
			},
			highlightBd: true,
			editForm: {
				from: "",
				to: "",
				dtls: []
			},

			oneList: [],
			twoList: []
		};
	},
	components: {
		conditionEdit
	},
	created() {},
	methods: {
		//显示新增界面
		showEdit() {
			this.getTreeListData();
		},

		// from节点点击
		handleNodeClickFrom(node) {
			if (node.subList.length === 0) {
				this.editForm.from = node.keyId;
			}
		},

		// to节点点击
		handleNodeClickTo(node) {
			if (node.subList.length === 0) {
				this.editForm.to = node.keyId;
				this.getMenuConditionDtlList();
			}
		},

		// 点击新增
		addCondition() {
			this.$refs.conditionEdit.editShow();
		},

		// 更新条件数据
		updateDtls(data) {
			this.oneList = [];
			this.twoList = [];
			this.editForm.dtls.push(data);
			this.editForm.dtls.forEach((item) => {
				if (item.type === "1") {
					this.oneList.push(item);
				} else {
					this.twoList.push(item);
				}
			});
		},

		// 获取菜单树数据
		getTreeListData() {
			this.loading = true;
			GetMenuTreeAllList()
				.then((res) => {
					if (res.code == 1) {
						this.loading = false;
						this.listDataFrom = res.data;
						this.listDataTo = res.data;
					} else {
						this.$message({
							type: "info",
							message: res.msg
						});
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("数据加载失败，请稍后再试！");
				});
		},

		// 获取菜单连接线之间的条件
		getMenuConditionDtlList() {
			this.oneList = [];
			this.twoList = [];
			let param = {
				from: this.editForm.from,
				to: this.editForm.to
			};
			GetMenuConditionDtlList(param)
				.then((res) => {
					if (res.code == 1) {
						this.editForm.dtls = res.data;
						this.editForm.dtls.forEach((item) => {
							if (item.type === "1") {
								this.oneList.push(item);
							} else {
								this.twoList.push(item);
							}
						});
					} else {
						this.$message({
							type: "info",
							message: res.msg
						});
					}
				})
				.catch((err) => {
					this.$message.error("数据加载失败，请稍后再试！");
				});
		},

		// 编辑、增加页面保存方法
		submitForm() {
			this.saveloading = true;
			SaveMenuCondition(this.editForm)
				.then((res) => {
					if (res.code == 1) {
						this.$message({
							type: "success",
							message: "保存成功！"
						});
						this.saveloading = false;
					} else {
						this.$message({
							type: "info",
							message: res.msg
						});
						this.saveloading = false;
					}
				})
				.catch((err) => {
					this.editFormVisible = false;
					this.saveloading = false;
					this.$message.error("保存失败，请稍后再试！");
				});
		}
	}
};
</script>
<style scoped>
.add_bg {
	width: 100%;
	height: calc(100vh - 115px);
	background: #fff;
	display: flex;
}

.left {
	width: 300px;
	height: 100%;
	border-right: 1px solid #dddddd;
}

.middle {
	width: 300px;
	height: 100%;
	border-right: 1px solid #dddddd;
}

.right {
	width: calc(100% - 600px);
	height: 100%;
	position: relative;
}

.title_div {
	padding: 15px 20px;
	font-size: 14px;
	font-weight: 600;
}

.pz_div {
	display: flex;
}

.pz_content {
	width: 300px;
	min-height: 200px;
	border: 1px solid #d5d5d5;
	margin-left: 30px;
	padding: 10px 15px;
}

.bg_title {
	font-size: 12px;
	font-weight: 600;
	color: #55aaff;
	margin-bottom: 15px;
}

.add_btn {
	margin-left: 30px;
	margin-bottom: 20px;
}

.pz_c {
	display: flex;
	flex-wrap: wrap;
}

.pz_item {
	padding: 4px 10px;
	background: #9bdcff;
	border: 1px solid #fff;
	font-size: 12px;
	color: #ffffff;
	border-radius: 4px;
	margin-right: 15px;
}

.save_btn {
	position: absolute;
	bottom: 40px;
	right: 40px;
}

.one_01 {
	padding-left: 20px;
	padding-right: 20px;
}
</style>
